import React from 'react';

import pneumo from '../../imgs/pneumo.jpg';

export default class Hyperloop1 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
        <h1> Пневпомочта</h1>
        <p>
        По некоторым данным основы пневмотранспорта были заложены еще в первом
        столетии нашей эры греческим инженером Героном Александрийским в его
        трактате «Пневматика».
        </p>
        <p>
        Пневмопочта – перемещение штучных или сыпучих объектов в легкой капсуле при
        помощи разреженного воздуха или частичного вакуума, генерируемого в
        замкнутой (часто подземной) трубе, была изобретена английским инженером
        Уильямом Мердоком в первой половине XIX века.
        </p>
        <p>
        Широкое распространение, однако, пневмопочта получила лишь к началу XX
        века, и до сих пор используется некоторыми учреждениями, например банками
        (Сбербанк) и некоторыми торговыми сетями (IKEA, Media Markt).
        </p>
        <p>
        Идея же о практическом перемещении не только грузов, но и людей при помощи
        создания искусственных неоднородностей в давлении воздуха появилась в 1812
        году, когда английский изобретатель Джордж Мэдхерст поделился ею с научным
        сообществом.
        </p>
        <p>
        В частности, он предлагал две возможные версии нового вида транспорта: либо
        капсула сама по себе должна была стать поршнем, на который действует
        давление воздуха в железной трубе, либо она должна была быть соединена с
        небольшим поршнем, который вводится в трубу и под воздействием сжатого или
        разреженного перемещает вагон.
        </p>
        <p>
        Первый вариант с некоторыми допущениями можно назвать предшественником
        концепций вакуумных поездов и даже самого Hyperloop, однако второй оказался
        более реализуем для технологий первой половины XIX века. Впрочем, при жизни
        Мэдхерста ни один из них реализован так и не был.
        </p>
        <p align='center'>
          <img className='responsive-img' src={pneumo} alt='' />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Hyperloop-1.js